const baseFormats = {
  'short': {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },
  'long': {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  'zh-cn': {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
  },
}

const languages = ['en', 'pt-br', 'es-la', 'zh-cn', 'de', 'ja']

export const dateFormats = languages.reduce((accumulator, lang) => {
  accumulator[lang] = { ...baseFormats }
  return accumulator
}, {})
